import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

export default function useInvitationsList() {

	// Use toast
	const toast = useToast();

	const refInvitationListTable = ref(null);

	const styleColumns = {
		thClass: 'text-center',
		tdClass: 'text-center'
	}

	// Table Handlers
	let tableColumns = [
		{ key: 'tender_code', sortable: true, label: 'CÓDIGO <br/> LICITACIÓN', ...styleColumns },
		{ key: 'bidder_name', sortable: true, label: 'POSTOR', thClass: styleColumns.thClass },
		{ key: 'status', sortable: true, label: 'ESTADO <br/> INVITACIÓN', ...styleColumns },
		{ key: 'sent_at', sortable: true, label: 'FECHA <br/> ENVIADA', ...styleColumns },
		{ key: 'invitation_answered_at', sortable: true, label: 'FECHA <br/> REGISTRO', ...styleColumns },
	];

	const perPage = ref(10);
	const totalInvitations = ref(0);
	const currentPage = ref(1);
	const perPageOptions = [10, 25, 50, 100];
	const searchQuery = ref('');
	const sortBy = ref('id');
	const isSortDirDesc = ref(true);

	const dataMeta = computed(() => {
		const localItemsCount = refInvitationListTable.value ? refInvitationListTable.value.localItems.length : 0;
		return {
			from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
			to: perPage.value * (currentPage.value - 1) + localItemsCount,
			of: totalInvitations.value,
		}
	});

	const refetchData = () => {
		refInvitationListTable.value.refresh();
	};

	watch([currentPage, perPage, searchQuery], () => {
		refetchData();
	});

	const fetchInvitations = (ctx, callback) => {
		store
			.dispatch('app-invitation/fetchInvitations', {
				q: searchQuery.value,
				perPage: perPage.value,
				page: currentPage.value,
				sortBy: sortBy.value,
				sortDesc: isSortDirDesc.value
			})
			.then(response => {
				const { invitations, total } = response.data;
				callback(invitations);
				totalInvitations.value = total;
			})
			.catch(() => {
				toast({
					component: ToastificationContent,
					props: {
						title: 'Error al obtener la lista de invitaciones',
						icon: 'AlertTriangleIcon',
						variant: 'danger'
					}
				});
			})
	};

	return {
		fetchInvitations, tableColumns,
		perPage,
		currentPage,
		totalInvitations,
		dataMeta,
		perPageOptions,
		searchQuery,
		sortBy,
		isSortDirDesc,
		refInvitationListTable,

		refetchData
	}
}